import { useState, useEffect, useRef } from 'react';
import { Skeleton } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import classes from './JobList.module.scss';

import JobCard from '../JobCard/JobCard';

import JobDetails from '../JobDetails/JobDetails';
import { useWindowSize } from '../../../../utils/hooks';
import { jobsPageSize } from '../../../../utils/constants';
import BaseSwipeableDrawer from '../../../common/BaseSwipeableDrawer/BaseSwipeableDrawer';

import JobDetailsMobile from '../JobDetailsMobile/JobDetailsMobile';

const asideMinWidth = 1200;

const JobList = (props) => {
  const { jobs, pending, tabs } = props;

  const { width, height } = useWindowSize();
  const [params] = useSearchParams();
  const actionParam = params.get('action');
  const [sideCard, setSideCard] = useState();
  const cardsContainerRef = useRef(null);
  const [cardsHeight, setCardsHeight] = useState(0);

  useEffect(() => {
    if (jobs?.length && !actionParam && width > asideMinWidth) setSideCard(jobs[0]);
    if (!pending && !sideCard && !actionParam && width > asideMinWidth && jobs?.length) setSideCard(jobs[0]);
    if (!pending && !jobs?.length) setSideCard(null);
  }, [pending, jobs]);

  useEffect(() => {
    if (width <= asideMinWidth && actionParam) {
      setSideCard(null);
    }
  }, [params]);

  useEffect(() => {
    if (!cardsContainerRef.current || width <= asideMinWidth) return undefined;
    const el = cardsContainerRef.current;
    const observer = new ResizeObserver(([entry]) => setCardsHeight(entry.contentRect.height));
    observer.observe(el);
    return () => observer.disconnect();
  }, [width, jobs, pending]);

  return (
    <section className={classes.jobsSectionWrapper}>
      <div className={classes.cardsContainer} ref={cardsContainerRef}>
        {pending
          ? Array.from({ length: jobsPageSize }, (v, k) => k).map((item) => (
              <Skeleton
                variant="rectangular"
                key={item}
                width={width > asideMinWidth ? '474px' : '100%'}
                height={width > asideMinWidth ? '130px' : '100px'}
                sx={{ borderRadius: '10px' }}
              />
            ))
          : jobs?.map((job) => (
              <JobCard
                key={job?.Id}
                job={job}
                clickHandler={() => setSideCard(job)}
                isActive={sideCard && job?.Id === sideCard.Id}
                tabTypes={tabs}
              />
            ))}
      </div>
      <div
        className={classes.cardContainer}
        style={{ height: `${Math.max(cardsHeight, height ? height - 110 : 0)}px` }}
      >
        {sideCard && jobs?.length ? <JobDetails job={sideCard} /> : undefined}
      </div>
      {width <= asideMinWidth && sideCard && jobs?.length && (
        <BaseSwipeableDrawer height="auto" open closeHandler={() => setSideCard(null)}>
          <JobDetailsMobile job={sideCard} />
        </BaseSwipeableDrawer>
      )}
    </section>
  );
};

export default JobList;
